module.exports = __webpack_public_path__ + "assets/img/00085.31b545db.png";